var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Retificar Cadastro", width: 600 },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c("template", { slot: "body" }, [
        _c("p", { staticClass: "color-green" }, [
          _vm._v("Passo a passo para o download do .sicarf")
        ]),
        _c("div", { staticClass: "margin-left" }, [
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("1.")]),
            _vm._v("  Realizar o download do .sicarf;")
          ]),
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("2.")]),
            _vm._v(
              "  Importar o .sicarf no Módulo Offline na opção 'Importar cadastro';"
            )
          ]),
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("3.")]),
            _vm._v("  Realizar as retificações necessárias no cadastro;")
          ]),
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("4.")]),
            _vm._v(
              "  Após a retificação, realizar o download do .sicarf retificado;"
            )
          ]),
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("5.")]),
            _vm._v("  Importar o .sicarf novamente no Módulo Receptor;")
          ]),
          _c("p", [
            _c("span", { staticClass: "color-green" }, [_vm._v("6.")]),
            _vm._v("  O cadastro voltará para a caixa de entrada do setor.")
          ])
        ])
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeModal } },
              [_c("b", [_vm._v("Cancelar")])]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "success", size: "small" },
                on: { click: _vm.download }
              },
              [
                _c("i", { staticClass: "fal fa-download" }),
                _vm._v("  Download")
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e9ec2c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9ec2c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalRetificacaoCadastro.vue
// module id = null
// module chunks = 